<script>
export default {
  props: {
    items: Array,
  },
};
</script>
<template>
  <div v-if="items">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="mag-history-tile"
    >
      <div class="mag-history-tile__title">
        <div class="mag-history-tile__action">{{item.Action}}</div>
        <div class="mag-history-tile__time">{{item.Created.Serialized}}</div>
      </div>
      <div class="mag-history-tile__discription">
        {{item.Description}}
      </div>
      <div
        v-if="item.UserName"
        class="mag-history-tile__user"
      >
        Пользователь: <b>{{item.UserName}}</b>
      </div>
    </div>
  </div>
</template>
